import { cartFieldsQuery } from './getCart'
import { gql } from './gql'

/**
 * Claims a promotion the cart already earned but has not applied yet.
 *
 * `Cart.deferredPromotions` is the backend saying "this basket qualifies for
 * one of these, tell me which one". Until something sends this mutation the
 * reward is not on the order, so a storefront that reads `deferredPromotions`
 * and never writes back is leaving the shopkeeper's own money on the table.
 *
 * `data.selectBy` is what makes the call meaningful:
 * `DEFAULT_GROUP_ID` for a promotion whose reward is already decided, and
 * `CUSTOMER_SELECTION` with `selectedGroupIdentifier` for one where the shopper
 * picks between `promotion.customerGets.groups`. The two criteria the schema
 * also has — `QUANTITY_SELECTION` and `REFUSED` — are not sent from here; see
 * `docs/NOT_PORTED.md`.
 *
 * It answers with the whole `Cart`, so — like `cartAddProduct` and
 * `prefillCart` — Apollo writes it onto the normalised `Cart:<id>` entity and
 * every open query repaints without a refetch. That matters more here than
 * elsewhere: activating a promotion changes the lines, the totals *and* the
 * list of deferred promotions the shopper is looking at.
 */
export const ACTIVATE_DEFERRED_PROMOTION = gql`
  mutation ActivateDeferredPromotion(
    $storefrontName: String!
    $sessionUid: ID!
    $data: ActivateDeferredPromotionDataInput!
  ) {
    activateDeferredPromotion(
      storefrontName: $storefrontName
      sessionUid: $sessionUid
      data: $data
    ) {
      ${cartFieldsQuery}
    }
  }
`
